import React, { useState } from 'react';
import styles from './AppCard.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';



// خريطة أيقونات أنواع الروابط (links)
const linkTypeMap = {
  windows: { iconClass: 'fa-brands fa-microsoft', isImage: false },
  android: { iconClass: 'fa-solid fa-mobile', isImage: false },
  androidtv: { iconClass: 'fa-brands fa-android', isImage: false },
  webos: { iconClass: 'fas fa-tv', isImage: false },
  tizenos: { iconClass: 'fas fa-tv', isImage: false },
  ios: { iconClass: 'fa-brands fa-app-store', isImage: false },
  googleplay: { iconClass: 'fa-brands fa-google-play', isImage: false },



  instagram: { iconClass: 'fa-brands fa-instagram', isImage: false },
  whatsapp: { iconClass: 'fa-brands fa-whatsapp', isImage: false },
  telegram: { iconClass: 'fa-brands fa-telegram', isImage: false },
  channel: { iconClass: 'fa-brands fa-channel', isImage: false },
  github: { iconClass: 'fa-brands fa-github', isImage: false },
  website: { iconClass: 'fa-solid fa-globe', isImage: false },
  apkmirror: { iconSrc: '/dl/pic/apkmirror2.png', isImage: true },
  backup: { iconClass: 'fa-solid fa-cloud', isImage: false },
  old: { iconClass: 'fa-solid fa-backward', isImage: false },
  beta: { iconClass: 'fa-solid fa-flask', isImage: false }, 
};

function AppCard({ app }) {
  const [showCode, setShowCode] = useState(false);

  const toggleCodeVisibility = () => {
    setShowCode(!showCode);
  };

  const renderOsIcon = (osIcon, index) => {
    if (osIcon.type === 'font-awesome') {
      return (
        <a
          key={index}
          href={osIcon.href}
          target="_blank"
          rel="noopener noreferrer"
          title={osIcon.title || osIcon.iconClass}
          className={styles.osLink}  // الصندوق الموحد
        >
          <i className={`${osIcon.iconClass} ${styles.osIcon}`}></i>
        </a>
      );
    } else if (osIcon.type === 'image') {
      return (
        <a
          key={index}
          href={osIcon.href}
          target="_blank"
          rel="noopener noreferrer"
          title={osIcon.title || osIcon.src}
          className={styles.osLink}  // نفس الصندوق الموحد
        >
          <img
            src={osIcon.src}
            alt={osIcon.title || 'OS Icon'}
            className={styles.osImageIcon}
          />
        </a>
      );
    }
    return null;
  };

  const renderButton = (button, index) => {
    if (button.type === 'apk') {
      return (
        <a
          key={index}
          href={button.href}
          className={styles.downloadBtn}
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* ضع الأيقونة داخل صندوق */}
          {button.iconClass && (
            <span className={styles.osLink} style={{ marginRight: '8px', width: '30px', height: '30px' }}>
              <i className={button.iconClass} style={{ fontSize: '18px' }}></i>
            </span>
          )}
          {button.text}
        </a>
      );
    } else if (button.type === 'code') {
      return (
        <button
          key={index}
          className={styles.codeBtn}
          onClick={toggleCodeVisibility}
          aria-expanded={showCode}
          aria-controls="codeOverlay"
        >
          {button.iconClass && (
            <span className={styles.osLink} style={{ marginRight: '8px', width: '30px', height: '30px' }}>
              <i className={button.iconClass} style={{ fontSize: '18px' }}></i>
            </span>
          )}
          {button.text}
        </button>
      );
    }
    return null;
  };

  // رسم روابط التحميل والروابط الخارجية حسب type
  const renderLinks = () => {
    if (!app.links || app.links.length === 0) return null;

    return (
      <div className={styles.linksContainer}>
        {app.links.map((link, idx) => {
          const mapItem = linkTypeMap[link.type];
          if (!mapItem) return null;

          return (
            <a
              key={idx}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              title={link.type}
              className={styles.osLink}  // نفس صندوق الأيقونات
            >
              {mapItem.isImage ? (
                <img
                  src={mapItem.iconSrc}
                  alt={link.type}
                  className={styles.osImageIcon}
                  loading="lazy"
                />
              ) : (
                <i className={mapItem.iconClass}></i>
              )}
            </a>
          );
        })}
      </div>
    );
  };

  return (
    <div className={styles.appCard}>

      <img src={app.icon} alt={app.name} className={styles.appImage} />

      <h3 className={styles.appName}>{app.name}</h3>

      {Array.isArray(app.meta) ? (
        app.meta.map((m, index) => (
          <p key={index} className={styles.appMeta}>
            {m}
          </p>
        ))
      ) : (
        <p className={styles.appMeta}>{app.meta}</p>
      )}

      {app.osIcons && app.osIcons.length > 0 && (
        <div className={styles.osIconsContainer}>
          {app.osIcons.map(renderOsIcon)}
        </div>
      )}

      {/* روابط التحميل والروابط الخارجية حسب type */}
      {renderLinks()}

      {showCode && (
        <div
          id="codeOverlay"
          className={styles.codeOverlay}
          role="dialog"
          aria-modal="true"
          aria-label="App code"
        >
          <div className={styles.codeContent}>
            <p className={styles.codeText}>
              {app.buttons.find((btn) => btn.type === 'code')?.code}
            </p>
            <button
              className={styles.closeCodeBtn}
              onClick={toggleCodeVisibility}
              aria-label="Close code overlay"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
      )}

      <div className={styles.appButtons}>{app.buttons && app.buttons.map(renderButton)}</div>
    </div>
  );
}

export default AppCard;
